import { Box, Card, CardContent, Typography, Paper } from '@mui/material';
import { LayoutBaseDePagina } from '../../shared/layouts';

export const PaginaInicial = () => {
    return (

            <Box width="100%" display="flex" flexDirection="column" alignItems="center" padding={2}>
                {/* Header Section */}
                <Paper elevation={3} style={{ width: '90%', marginBottom: '20px', padding: '20px', textAlign: 'center' }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Sistema de Venda de Internet via Bilhete
                    </Typography>
                    <Typography variant="body1">
                        Transforme seu Wi-Fi em uma fonte de renda com nossa solução prática e eficiente.
                    </Typography>
                </Paper>

                {/* Features Section */}
                <Box display="flex" flexWrap="wrap" justifyContent="center" gap={2}>
                    <Card style={{ maxWidth: 300 }}>
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Controle Total
                            </Typography>
                            <Typography variant="body2">
                                Escolha o tempo de uso e dados de cada bilhete. Gerencie sua rede com facilidade.
                            </Typography>
                        </CardContent>
                    </Card>

                    <Card style={{ maxWidth: 300 }}>
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Lucro Garantido
                            </Typography>
                            <Typography variant="body2">
                                Venda bilhetes e transforme sua internet em um negócio lucrativo.
                            </Typography>
                        </CardContent>
                    </Card>

                    <Card style={{ maxWidth: 300 }}>
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Relatórios Simples
                            </Typography>
                            <Typography variant="body2">
                                Acompanhe suas vendas diárias, semanais e mensais para tomar decisões estratégicas.
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>

                {/* Call to Action Section */}
                <Paper elevation={3} style={{ width: '90%', marginTop: '20px', padding: '20px', textAlign: 'center' }}>
                    <Typography variant="h5" gutterBottom>
                        Pronto para Começar?
                    </Typography>
                    <Typography variant="body1">
                        Entre em contato e ative o sistema hoje mesmo. Aumente sua receita sem riscos e com controle total.
                    </Typography>
                </Paper>
            </Box>

    );
};
